import { useMutation } from '@tanstack/react-query';

import { videoCallService, type JoinCallResponse } from '../services';

/**
 * Mutation hook for POST /sessions/:id/call/join on elixaa-realtime.
 * Returns the LiveKit connection payload. Consumers wire this to a
 * route's onMount or to a button's onClick and surface loading /
 * error states from the mutation result.
 *
 * No query-cache interaction — the token is short-lived (4h) and
 * caller-scoped. Don't invalidate anything.
 */
export function useJoinCall() {
  return useMutation<JoinCallResponse, Error, string>({
    mutationFn: (sessionId) => videoCallService.joinCall(sessionId),
  });
}
